import React, { useState } from "react"
import { StructuredText } from "react-datocms"

import { AccordionWrapper } from "../styles/SlideBoxAccordion.styled"
import { VariantSlideWrap } from "../styles/SlideVariant.styled"

import AccordionItem from "./AccordionItem"

const SlideBoxAccordion = ({ component, headingSize }) => {
  const [opened, setOpened] = useState({})

  const handleClick = (index) => {
    setOpened({
      [index]: !opened[index],
    })
  }
  return (
    <AccordionWrapper>
      <VariantSlideWrap>
        <div className="heading-container">
          {component?.eyebrow && (
            <p className="heading-kicker eyebrow">{component?.eyebrow}</p>
          )}
          {component?.heading && (
            <h2 className={`heading ${headingSize}`}>{component?.heading}</h2>
          )}
          {component?.slideBoxBody && (
            <div className="description">
              <StructuredText
                data={component?.slideBoxBody}
                renderInlineRecord={() => {}}
              />
            </div>
          )}
        </div>
        {component?.variantSlides &&
          component?.variantSlides.map((slide, index) => (
            <AccordionItem
              key={slide?.id || index}
              index={index}
              navLabel={slide?.navLabel}
              heading={slide?.heading}
              subhead={slide?.subhead}
              image={slide?.image}
              handleClick={handleClick}
              opened={opened}
            />
          ))}
      </VariantSlideWrap>
    </AccordionWrapper>
  )
}

export default SlideBoxAccordion
